import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import theme from "components/MuiThemeProvider/theme";

const size = {
  extraSmall: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6.99984" cy="7.00033" r="5.83333" fill={theme.palette.success.main} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0376 5.12886C10.2654 5.35667 10.2654 5.72601 10.0376 5.95382L6.82931 9.16215C6.6015 9.38996 6.23216 9.38996 6.00435 9.16215L4.25435 7.41215C4.02654 7.18435 4.02654 6.815 4.25435 6.5872C4.48216 6.35939 4.8515 6.35939 5.07931 6.5872L6.41683 7.92472L9.21268 5.12886C9.44049 4.90106 9.80984 4.90106 10.0376 5.12886Z"
        fill="white"
      />
    </svg>
  ),
  small: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9.99996" cy="10.0003" r="8.33333" fill={theme.palette.success.main} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3393 7.32709C14.6647 7.65252 14.6647 8.18016 14.3393 8.5056L9.75596 13.0889C9.43053 13.4144 8.90289 13.4144 8.57745 13.0889L6.07745 10.5889C5.75201 10.2635 5.75201 9.73586 6.07745 9.41042C6.40289 9.08498 6.93053 9.08498 7.25596 9.41042L9.16671 11.3212L13.1608 7.32709C13.4862 7.00165 14.0139 7.00165 14.3393 7.32709Z"
        fill="white"
      />
    </svg>
  ),
  default: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill={theme.palette.success.main} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2071 8.79289C17.5976 9.18342 17.5976 9.81658 17.2071 10.2071L11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L11 13.5858L15.7929 8.79289C16.1834 8.40237 16.8166 8.40237 17.2071 8.79289Z"
        fill="white"
      />
    </svg>
  ),
  large: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill={theme.palette.success.main} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2071 8.79289C17.5976 9.18342 17.5976 9.81658 17.2071 10.2071L11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L11 13.5858L15.7929 8.79289C16.1834 8.40237 16.8166 8.40237 17.2071 8.79289Z"
        fill="white"
      />
    </svg>
  ),
};

function SuccessIcon(props: SvgIconProps) {
  const fontSize = ["extraSmall", "small", "large"].includes(props.fontSize as "extraSmall" | "small" | "large")
    ? props.fontSize
    : "default";
  const item = size[fontSize as "extraSmall" | "small" | "large" | "default"];

  return (
    <SvgIcon {...props} data-svg="SuccessIcon">
      {item}
    </SvgIcon>
  );
}

export default SuccessIcon;
